import { getValueFromContent } from '../../utils';
import { onLocationChange, selectActiveItem } from './utils';

export const productMenuPlugin = {
  beforeRender({ header, params, content }) {
    const parsedItems = getValueFromContent(params.items, content);

    if (process.env.RUNTIME === 'browser') {
      selectActiveItem(parsedItems, content);
    }

    Array.isArray(parsedItems) &&
      (header.productNav = {
        type: '@sitebase/product-menu',
        data: {
          id: 'hrs-product-nav',
        },
        children: parsedItems.map((item) => ({
          type: '@sitebase/product-menu-item',
          data: {
            label: item.label,
            id: `product-menu-item-${item.label}`,
            link: {
              url: item.url,
            },
            redirectToProduct: params.redirectToProduct,
          },
        })),
      });
  },
  afterRender({ params, content }) {
    const parsedItems = getValueFromContent(params.items, content);
    onLocationChange(() => selectActiveItem(parsedItems, content));
  },
};
